"use strict";
import React from "react";
var ButtonColor = /* @__PURE__ */ ((ButtonColor2) => {
  ButtonColor2["Primary"] = "primary";
  ButtonColor2["Destruct"] = "destruct";
  return ButtonColor2;
})(ButtonColor || {});
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["Large"] = "large";
  ButtonSize2["Medium"] = "medium";
  ButtonSize2["Small"] = "small";
  return ButtonSize2;
})(ButtonSize || {});
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["Filled"] = "filled";
  ButtonVariant2["Outlined"] = "outlined";
  ButtonVariant2["Text"] = "text";
  return ButtonVariant2;
})(ButtonVariant || {});
function Button(props) {
  const classes = [
    "v3__button",
    `v3__button--color-${props.color || "primary" /* Primary */}`,
    `v3__button--size-${props.size || "large" /* Large */}`,
    `v3__button--variant-${props.variant || "filled" /* Filled */}`
  ];
  if (props.disabled) {
    classes.push("v3__button--disabled");
  }
  if (props.href) {
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        href: props.href,
        target: props.target,
        className: classes.join(" "),
        onClick: props.onClick,
        style: props.style
      },
      /* @__PURE__ */ React.createElement("span", { className: "v3__button--label-wrapper" }, props.children)
    );
  } else {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: classes.join(" "),
        onClick: props.onClick,
        style: props.style
      },
      /* @__PURE__ */ React.createElement("span", { className: "v3__button--label-wrapper" }, props.children)
    );
  }
}
export { Button, ButtonSize, ButtonVariant };
